import { OrderPatient } from 'models/order';
import { User } from 'models/user';

/**
 * DD-3494: an order may carry no patient details (withheld from a
 * subcontractor) and no responsible user. Display sites format through these
 * helpers so the UI shows a deliberate placeholder, never "undefined undefined".
 * Callers pass the translated placeholder, e.g. t('orders:NO_PATIENT_REFERENCE').
 */

export const NO_RESPONSIBLE_USER_PLACEHOLDER = '—';

export const formatPatientName = (patient: OrderPatient | undefined | null, noPatientLabel: string): string => {
    // A withheld patient can arrive as null or as an object without names.
    const fullName = [patient?.firstName, patient?.lastName].filter(Boolean).join(' ');
    return fullName || noPatientLabel;
};

export const formatPatientId = (patient: OrderPatient | undefined): string => patient?.personalIdentityNumber ?? '';

export const formatResponsibleUser = (responsibleUser: User | undefined): string => {
    const name = responsibleUser?.name;
    if (!name?.firstName && !name?.lastName) return NO_RESPONSIBLE_USER_PLACEHOLDER;
    return [name.firstName, name.lastName].filter(Boolean).join(' ');
};
